// src/components/vision/VisionPrinciplesSection.tsx
import React from 'react';
import clsx from 'clsx'; // <--- THIS IS THE FIX. ADD THIS IMPORT.
import { ContentCard } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';

interface PrincipleItem {
  iconName: string;
  title: string;
  text: string;
}

interface PrinciplesData {
  headline: string;
  items: PrincipleItem[];
}

interface VisionPrinciplesSectionProps {
  principlesData: PrinciplesData;
}

export const VisionPrinciplesSection: React.FC<VisionPrinciplesSectionProps> = ({ principlesData }) => {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
          {principlesData.headline}
        </h2>

        {/* Using a 2-column then 3-column grid for better responsive flow with 5 items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {principlesData.items.map((item, index) => (
            <div 
              key={index} 
              // This makes the last item span 2 columns on lg screens if it's the 5th item
              className={clsx(
                {'lg:col-span-1': index < 3},
                // Correct logic for 5 items: items at index 3 and 4 should span half the width on lg screens
                // A better approach is to make the container for the last two items a subgrid or flex container if needed,
                // but for simplicity, let's just make the grid flow naturally and center the last row.
                // A simpler grid for 5 items:
                { 'md:col-span-1': true }, // Each card takes 1 column on medium screens
                { 'lg:last:col-start-2': principlesData.items.length === 5 }, // Center the last item on a new row for lg screens if there are 5
              )}
            >
              <ContentCard
                icon={renderIcon(item.iconName, { size: 28, className: "text-emerald-600" })}
                iconContainerClassName="p-3 bg-emerald-100 border-2 border-black rounded-lg w-fit"
                title={item.title}
                text={item.text}
                index={index}
                className="h-full"
                hoverEffect="lift"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

